import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 48 48" {...props}><path d="M17 16h4.5v16H17V16zm9.5 0H31v16h-4.5V16z" fillRule="evenodd" /></svg>);